module.exports = __webpack_public_path__ + "240af140f3f9494996b3743f3f93cc82.svg";